import React, { useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import { useCreateInvestigation_Mutation } from '../queries/queries';
import { InvestigationCreateParams } from '../queries/zod';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const FormSchema = z.object({
  investigationParams: InvestigationCreateParams,
  setAsCurrent: z.boolean(),
});

const InternalModal = ({
  show,
  handleClose,
  handleSubmit,
  register,
  errors,
  onSubmit,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enter Investigation Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId='name'>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter name'
              {...register('investigationParams.name')}
              isInvalid={!!errors.investigationParams?.name}
            />
            {errors.investigationParams?.name && (
              <Form.Control.Feedback type='invalid'>
                {errors.investigationParams.name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          {/* Checkbox Field */}
          <Form.Group controlId='setAsCurrent' className='mt-3'>
            <Form.Check
              type='checkbox'
              label='Set as Current Investigation'
              {...register('setAsCurrent')}
            />
          </Form.Group>

          <div className='d-flex justify-content-end mt-3'>
            <Button variant='secondary' onClick={handleClose} className='me-2'>
              Cancel
            </Button>
            <Button type='submit' variant='primary'>
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const CreateInvestigationModal = () => {
  const [show, setShow] = useState(false);

  const { mutate: createInvestigation } = useCreateInvestigation_Mutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      investigationParams: { name: '' },
      setAsCurrent: false,
    },
  });

  const handleClose = () => {
    reset();
    setShow(false);
  };

  const handleShow = () => setShow(true);

  /**
   * @param {z.infer<FormSchema>} data
   */
  const onSubmit = (data) => {
    createInvestigation(data);
    handleClose();
  };

  return (
    <>
      <Button onClick={handleShow} variant='falcon-primary'>
        <FontAwesomeIcon icon={['fas', 'plus']} />
      </Button>
      <InternalModal
        show={show}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        onSubmit={onSubmit}
      />
    </>
  );
};

export const CreateInvestigationModalDropdownItem = () => {
  const [show, setShow] = useState(false);

  const { mutate: createInvestigation } = useCreateInvestigation_Mutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      investigationParams: { name: '' },
      setAsCurrent: false,
    },
  });

  const handleClose = () => {
    reset();
    setShow(false);
  };

  const handleShow = () => setShow(true);

  /**
   * @param {z.infer<FormSchema>} data
   */
  const onSubmit = (data) => {
    createInvestigation(data);
    handleClose();
  };

  return (
    <>
      <Dropdown.Item onClick={handleShow} className='text-primary'>
        Create Investigation
      </Dropdown.Item>
      <InternalModal
        show={show}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default CreateInvestigationModal;

